import {
    ADD_CURRENCY_FAILD,
    ADD_CURRENCY_LOADING,
    ADD_CURRENCY_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const addNewCurrencyReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case ADD_CURRENCY_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_CURRENCY_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action.payload.status,
                mesg:action.payload.data.message,
                error: null,
            };
        case ADD_CURRENCY_FAILD:
           
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




